/* Source: src/mt-includes/widgets/google_search/src/frontend/init.js*/
angular.module('website.widget.google_search', [
    'ngSanitize',
    'website.widget.google_search.directive',
    'website.widget.google_search.service'

]);
